const BLOCKED_ROLE_NAMES = {
  ROLE_GUEST: true,
  ROLE_INSTALLER: true,
  ROLE_GATEWAY: true,
};

function roleName(role) {
  return role && role.name;
}

// UI gate: who sees Settings → API keys. Final auth is on POST/GET/DELETE (e.g. 13501).
function canManageApiKeys(roles) {
  if (!roles || !roles.length) return false;
  if (roles.some(role => roleName(role) === 'ROLE_MANAGER')) return true;
  if (roles.some(role => BLOCKED_ROLE_NAMES[roleName(role)])) return false;
  return true;
}

// Role dropdown: block known non-assignable system roles; service/custom edge cases → API 13502.
function isAssignableApiKeyRole(role) {
  const name = roleName(role);
  if (!name || BLOCKED_ROLE_NAMES[name]) return false;
  return true;
}

function apiKeyErrorEntity(error) {
  const code = error && error.response && error.response.data && error.response.data.code;
  if (code === 13501) return 'apiKeysForbidden';
  if (code === 13502) return 'apiKeysRoleNotAssignable';
  if (code === 13503) return 'apiKeysNotFound';
  if (code === 13504) return 'apiKeysInvalidRequest';
  return 'notificationError';
}

export {
  canManageApiKeys,
  isAssignableApiKeyRole,
  apiKeyErrorEntity,
};
